import { IWidgetOptionItem } from '@livelike/javascript';

export type TrackNumberPredictionWidgetInteractedArgs = {
  value: number;
  widgetOption: IWidgetOptionItem;
};
